import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para formatear números de teléfono
 * Transforma "34.654654654" a "+34 654654654"
 */
@Pipe({
  name: 'formatPhone',
  standalone: true,
})
export class FormatPhonePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Convertir a string y limpiar espacios
    const cleanValue = String(value).trim();

    // Si contiene un punto, asumimos que es el formato "dialCode.number"
    if (cleanValue.includes('.')) {
      const parts = cleanValue.split('.');
      if (parts.length === 2) {
        const dialCode = parts[0].trim();
        const number = parts[1].trim();
        return `+${dialCode} ${number}`;
      }
    }

    // Si no tiene punto, devolver tal como está
    return cleanValue;
  }
}
